const equipmentcategories = {
	title: "Equipment Categories",
	stitle: "Equipment Category",
	new_title: "New Equipment Category",
	edit_title: "Edit Equipment Category: {name}",
	list_title: "List of Equipment Categories",
	list_subtitle: "Manage equipment categories",
	id: "ID",
	name: "Name",
	status: "Status",
	reference_id: "Reference ID",
};
export default equipmentcategories;